module.exports = __webpack_public_path__ + "img/sp_article_9.4e9f66f9.jpg";